export const getFileIconSourceFromMimeType = (mimeType: string): string => {
  const iconSourceMapLevelTwo: Record<string, string> = {
    'application/gzip': 'zip.svg',
    'application/json': 'json.svg',
    'application/mp4': 'video.svg',
    'application/pdf': 'pdf.svg',
    'application/x-abiword': 'zip.svg',
    'application/msword': 'doc.svg',
    'application/vnd.ms-powerpoint': 'powerpoint.svg',
    'application/vnd.rar': 'zip.svg',
    'application/rtf': 'txt.svg',
    'application/vnd.ms-excel': 'excel.svg',
    'application/zip': 'zip.svg',

    'audio/aac': 'audio.svg',
    'audio/mp4': 'audio.svg',
    'audio/mpeg': 'audio.svg',
    'audio/ogg': 'audio.svg',
    'audio/wav': 'audio.svg',
    'audio/webm': 'audio.svg',

    'image/apng': 'image.svg',
    'image/avif': 'image.svg',
    'image/png': 'image.svg',
    'image/giff': 'image.svg',
    'image/jpeg': 'image.svg',
    'image/svg+xml': 'svg.svg',
    'image/x-png': 'image.svg',
    'image/tiff': 'image.svg',
    'image/webp': 'image.svg',

    'text/plain': 'txt.svg',
    'text/csv': 'excel.svg',

    'video/ogg': 'video.svg',
  };

  if (mimeType in iconSourceMapLevelTwo) {
    return iconSourceMapLevelTwo[mimeType];
  }

  const iconSourceMapLevelOne: Record<string, string> = {
    application: 'doc.svg',
    audio: 'audio.svg',
    image: 'image.svg',
    text: 'txt.svg',
  };

  const parts = mimeType.split('/');

  if (parts[0] in iconSourceMapLevelOne) {
    return iconSourceMapLevelOne[parts[0]];
  }

  return 'generic.svg';
};
